// src/components/Plans/PlanList.tsx
import React from "react";
import PlanCard from "../PlanCard";
import { Plan } from "../dataTypes";

interface Props {
  plans: Plan[];
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

const PlanList: React.FC<Props> = ({ plans, onEdit, onDelete }) => (
  <div>
    {plans.map((plan) => (
      <PlanCard key={plan._id} plan={plan} onEdit={onEdit} onDelete={onDelete} />
    ))}
  </div>
);

export default PlanList;
